'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _detail = require('./detail.html');

var _detail2 = _interopRequireDefault(_detail);

var _detail3 = require('./detail.controller');

var _detail4 = _interopRequireDefault(_detail3);

require('./detail.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var detailComponent = {
  bindings: {
    item: "<",
    modelName: "<"
  },
  template: _detail2.default,
  controller: _detail4.default,
  controllerAs: "vm"
};

exports.default = detailComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/detail.component.js